import { Reveal } from "./Reveal";
import { Chapter } from "./Chapter";
import { useContent } from "@/lib/content";

export const Services = () => {
  const { services, chapters } = useContent();
  return (
  <section className="mx-auto max-w-7xl px-6 md:px-12 py-32 md:py-44" data-testid="services-section">
    <Chapter number="04" kicker={chapters.services.kicker} title={chapters.services.title} id="services" />
    <div className="mt-20 grid md:grid-cols-2 gap-8">
      {services.map((s, i) => (
        <Reveal key={`${s.title}-${i}`} delay={(i % 2) * 0.08}>
          <div
            className="group h-full border border-champagne bg-ivory p-8 md:p-10 hover:border-burgundy transition-colors duration-500"
            data-testid={`service-card-${i}`}
          >
            <span aria-hidden="true" className="font-serif text-2xl italic text-champagne">0{i + 1}</span>
            <h3 className="mt-6 font-serif text-2xl md:text-3xl font-medium text-burgundy leading-tight">{s.title}</h3>
            <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-rose">{s.context}</p>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-charcoal/70">{s.detail}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
  );
};
